$(document).ready(function(){
  $('.product__description .accordion-detail').hide();

  $('.product__description .accordion-title').click(function(){
    $('.product__description .accordion-title').not(this).removeClass('open');
    $('.product__description .accordion-detail').not($(this).next()).slideUp();
    $(this).toggleClass('open');
    $(this).next().slideToggle();
  });

  $('.footer-block .footer-block__heading').click(function(){
    $('.footer-block .footer-block__heading').not(this).removeClass('open');
    $('.footer-block .footer-block__heading').not(this).next().slideUp();
    $(this).toggleClass('open');
    $(this).next().slideToggle();
  });

});
